import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn, RichTextMarkdown } from './../../../components/includes/ui';
import { PageContentService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.featured === '-1') {
    errors.featured = VALIDATION.required;
  }

  if (values.product === '-1') {
    errors.product = VALIDATION.required;
  }

  if (values.category === '-1') {
    errors.category = VALIDATION.required;
  }

  if (!values.meta_description) {
    errors.meta_description = VALIDATION.required;
  } else if (values.meta_description.length > 255) {
    errors.meta_description = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.preview) {
    errors.preview = VALIDATION.required;
  } else if (values.preview.length > 255) {
    errors.preview = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.highlight) {
    errors.highlight = VALIDATION.required;
  } else if (values.highlight.length > 255) {
    errors.highlight = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.title) {
    errors.title = VALIDATION.required;
  } else if (values.title.length > 255) {
    errors.title = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class PageContentUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false,
      categories: ['asistencia', 'cobertura', 'promocion'],
      products: ['hogar', 'vida']
    };
  }

  componentDidMount(){
    this._Find(this.props.match.params.id);
  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    PageContentService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    PageContentService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/page-content');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, la página fue editada.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagenPreview = (file) => {
    this.props.dispatch(change('PageContentUpdate', 'image_preview', file.attachment[0] ));
  }

  onUploadImagenDetail = (file) => {
    this.props.dispatch(change('PageContentUpdate', 'image_detail', file.attachment[0] ));
  }

  render() {

    const { loading, sending, categories, products } = this.state;
    const { PageContentUpdate, handleSubmit, invalid } = this.props;
    
    return (
      <Section>
        <ToolbarPrimary title="Páginas"/>
        <BreadcrumbItem to='/page-content'>Páginas</BreadcrumbItem>
        <BreadcrumbItem to='/page-content/update'>Editar</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title="Edición de página"/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="title"
                          component={ InputTextField }
                          label="Título"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                        name="category"
                        component={SelectField}
                        label="Categoría" required>
                        <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                        {categories.map((category) => {
                          return (
                            <OptionField key={category} value={category}>{category}</OptionField>
                          )
                        })}
                      </Field>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                        name="product"
                        component={SelectField}
                        label="Producto" required>
                        <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                        {products.map((product) => {
                          return (
                            <OptionField key={product} value={product}>{product}</OptionField>
                          )
                        })}
                      </Field>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="preview"
                          component={ InputTextField }
                          label="Subtitulo"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="highlight"
                          component={ InputTextField }
                          label="Highlight"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="featured"
                          component={ SelectField }
                          label="Destacada" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                        name="hash_list"
                        component={InputTextField}
                        label="Hashtags (valores separados por coma)"
                        type="text"
                        required
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="meta_title"
                          component={ InputTextField }
                          label="Meta title"
                          type="text"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="meta_keywords"
                          component={ InputTextField }
                          label="Meta keywords"
                          type="text"
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Field
                          name="meta_description"
                          component={ InputTextField }
                          label="Meta description"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="image_preview"
                          type="hidden"
                          component={ InputTextField }
                      />
                      <Upload
                        button="Subir imagen (Destacada)"
                        file={ PageContentUpdate.image_preview }
                        onSuccess={ this.onUploadImagenPreview.bind(this) }
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="image_detail"
                          type="hidden"
                          component={ InputTextField }
                      />
                      <Upload
                        button="Subir imagen (Listado+Detalle)"
                        file={ PageContentUpdate.image_detail }
                        onSuccess={ this.onUploadImagenDetail.bind(this) }
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12}>
                      <Field
                          name="description"
                          component={ RichTextMarkdown }
                          label="Descipción"
                          type="text"
                          required={true}
                      />
                    </Grid>

                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/page-content">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons align="right">
                        <Btn aria-label="Guardar página" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                          Guardar página
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

PageContentUpdate = reduxForm({
  form: 'PageContentUpdate',
  validate,
  enableReinitialize: true
})(PageContentUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    PageContentUpdate: state.PageContentUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'PAGE_CONTENT_UPDATE',
        data: data
      });
    }
  }
}

PageContentUpdate = connect(
  state => ({
    initialValues: {
      title: state.PageContentUpdate.title,
      category: state.PageContentUpdate.category,
      product: state.PageContentUpdate.product,
      status: state.PageContentUpdate.status,
      hash_list: state.PageContentUpdate.hash_list,
      featured: state.PageContentUpdate.featured,
      preview: state.PageContentUpdate.preview,
      highlight: state.PageContentUpdate.highlight,
      description: state.PageContentUpdate.description,
      meta_title: state.PageContentUpdate.meta_title,
      meta_keywords: state.PageContentUpdate.meta_keywords,
      meta_description: state.PageContentUpdate.meta_description,
      image_preview: state.PageContentUpdate.image_preview,
      image_detail: state.PageContentUpdate.image_detail
    }
  })
)(PageContentUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(PageContentUpdate);
